import { render, staticRenderFns } from "./ChooseMemberAssignment.vue?vue&type=template&id=f5e28708&"
import script from "./ChooseMemberAssignment.vue?vue&type=script&lang=js&"
export * from "./ChooseMemberAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports